import css from 'styled-jsx/css';
import { colors } from '../../../../themes';

export default css`
  @keyframes progress-bar {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(250%);
    }
  }

  .sources-loader {
    background: ${colors.grayExtraLight};
    box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.1);
    padding: 13px 15px 13px 13px;
    position: relative;
  }

  .sticky {
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
  }

  .title {
    color: ${colors.grayDeep};
    font-size: 1.0625em;
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 5px;
  }

  p {
    font-size: 0.93em;
    margin: 0;
  }

  .image-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .image-wrapper img {
    display: none;
    height: 28px;
    margin: 5px 0;
    width: auto;
  }

  .image-wrapper img.active {
    display: block;
  }

  .progress-bar-animate {
    animation: progress-bar 1s linear infinite;
  }
`;



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoader/styles.js